import { useModal } from '@/composition/use-modal';
import { useUi } from '@/composition/use-ui';
import { useRestaurantStore } from '@/stores/restaurant.store';
import CajasService from '@/api/services/cajas.service';
import InputModal from '@/components/modals/InputModal.vue';
import { AlertType } from '@/interfaces/IAlert';
import { ICaja } from '@/interfaces/ICaja';
import { nextTick } from 'vue';

export function useCajaSelection() {
  const restaurantStore = useRestaurantStore();
  const modals = useModal();
  const ui = useUi();

  /**
   * Opens a modal to input the caja key and selects the caja if the key is correct.
   * @param caja The caja to select
   * @param onSuccess Optional callback when selection is successful
   * @param onCancel Optional callback when selection is cancelled
   */
  function selectCaja(
    caja: ICaja,
    onSuccess?: () => void,
    onCancel?: () => void
  ) {
    const oldCaja = restaurantStore.caja;

    let submitted = false;
    modals.show(
      InputModal,
      {
        title: 'Ingrese la clave de la caja',
        message: 'Debe ingresar la clave de la caja para poder seleccionarla',
        placeholder: 'Clave de la caja',
        rules: [(v: string) => /^[\-0-9\.,\-]{1,6}$/.test(v) || 'Solo números'],
        type: 'number',
      },
      {
        name: 'caja-key',
        adaptive: true,
        height: 'auto',
        scrollable: true,
        maxWidth: window.innerWidth * 0.95,
        width: 600,
        clickToClose: false,
      },
      {
        submit: async (input: string) => {
          submitted = true;
          try {
            await CajasService.checkKey(caja, +input);
            restaurantStore.setCaja(caja);
            onSuccess?.();
          } catch (e) {
            nextTick(() => {
              restaurantStore.setCaja(oldCaja);
            });
            ui.showToast(AlertType.Error, 'Clave incorrecta');
            onCancel?.();
          } finally {
            modals.hide('caja-key');
          }
        },
        closed: () => {
          if (!submitted) {
            nextTick(() => {
              restaurantStore.setCaja(oldCaja);
            });
            onCancel?.();
          }
        },
      }
    );
  }

  return {
    selectCaja,
  };
}
